import { createElement } from "@wordpress/element";

/** @format */
export default (function () {
  return createElement("svg", {
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "2",
    y: "3",
    width: "14",
    height: "12"
  }, createElement("path", {
    d: "M6.59631 11.9062L3.46881 8.77875L2.40381 9.83625L6.59631 14.0287L15.5963 5.02875L14.5388 3.97125L6.59631 11.9062Z",
    fill: "white"
  })), createElement("g", {
    mask: "url(#mask0)"
  }, createElement("rect", {
    width: "18",
    height: "18",
    fill: "white"
  })));
});
//# sourceMappingURL=check-icon.js.map